// src/api/axiosInstance.js
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`;

// Create an instance of Axios
export const axiosInstance = axios.create({
  baseURL: API_URL,
  // timeout: 10000,    // Timeout for requests
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken'); // Adding token to headers
    console.log(token, "token")
    if (token) {
      config.headers['authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle global errors (e.g., token expiration or network errors)
    if (error.response) {
      // Check if the response indicates an unauthorized user
      if (error.response.status === 401 || error.response.status === 403 || error.response.data.msg === "User not authorised") {
        console.log('Unauthorized, please login');

        // Clear the token from localStorage
        localStorage.removeItem('accessToken');

        // Redirect to the login page
        window.location.href = '/'; // Directly redirect to the login page
      } else if (error.response.status === 500) {
        console.log('Internal server error');
      }
    } else {
      console.log('Network error');
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
